import { Tag } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface ArticleCardTagProps {
  readonly tag: MessageKey;
  readonly textColor?:
    | 'olive-800'
    | 'sandstone-500'
    | 'text-brown-500'
    | undefined;
}

const ArticleCardTag = ({
  tag,
  textColor = 'sandstone-500',
}: ArticleCardTagProps) => {
  const t = useTranslations();
  return (
    <div className={textColor} data-cy="article-card-tag">
      <Tag>{t(tag)}</Tag>
    </div>
  );
};
export default ArticleCardTag;
